// extracted by mini-css-extract-plugin
module.exports = {"EmptyBox":"EmptyBoard_EmptyBox__FH_FM"};